import {useState} from "react";
import {useHistory, useLocation, useParams} from "react-router";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {useModal} from "@pg-design/modal-module";
import {Highlight, Text} from "@pg-design/text-module";
import {kmAppLink, SiteSlug} from "@pg-mono/km-routes";

import {Modal} from "../../../components/modal/Modal";
import {HomeMatchResignationSurvey} from "../../home_match/components/home_match_resignation_survey/HomeMatchResignationSurvey";
import {useHomeMatchResignationSurveySubmit} from "../../home_match/hooks/use_home_match_resignation_survey_submit";
import {zIndexes} from "../../km_app/constants/z_indexes";
import {usePostUserHomeMatchPreleadResignationMutation} from "../../user/api/user_api";
import {useHomeMatchPreferences} from "../../user/hooks/use_home_match_preferences";
import {hitHmRecommendationsUnsubscribe} from "../tracking/hit_hm_recommendations_unsubscribe";
import {getResignationSource} from "../utils/get_resignation_source";

enum HomeMatchUnsubscribeStep {
    SURVEY = "survey",
    SUCCESS = "success"
}

const closeText = "Zamknij";
const restoreText = "Przywróć teraz";

export const HomeMatchUnsubscribeView = () => {
    const params = useParams<{login_token: string}>();
    const location = useLocation();
    const history = useHistory();

    const [step, setStep] = useState(HomeMatchUnsubscribeStep.SURVEY);

    const [postUserHomeMatchPreleadResignation] = usePostUserHomeMatchPreleadResignationMutation();
    const {switchHomeMatchPreferences} = useHomeMatchPreferences();
    const {closeModal, modalProps} = useModal();

    const searchParams = new URLSearchParams(location.search);
    const resignationSource = getResignationSource({
        verifiedEmail: searchParams.get("verifiedEmail"),
        verifiedSMS: searchParams.get("verifiedSMS")
    });

    const handleCloseModal = () => {
        closeModal();
        history.push(kmAppLink.site.user.subscriptionWithParams({site: SiteSlug.KM}));
    };

    const handleSurveySubmit = useHomeMatchResignationSurveySubmit({
        disableHomeMatch: async () => {
            if (!params.login_token) throw new Error("Missing login token");

            await postUserHomeMatchPreleadResignation({login_token: params.login_token, resignation_source: resignationSource});
        },
        onError: handleCloseModal,
        onSuccess: () => setStep(HomeMatchUnsubscribeStep.SUCCESS)
    });

    const handleRestore = async () => {
        hitHmRecommendationsUnsubscribe(restoreText);
        await switchHomeMatchPreferences(true);
        handleCloseModal();
    };

    const handleClose = () => {
        hitHmRecommendationsUnsubscribe(closeText);
        handleCloseModal();
    };

    return (
        <Modal {...modalProps} isOpen zIndex={zIndexes.listingModal} onModalClose={handleCloseModal}>
            {step === HomeMatchUnsubscribeStep.SURVEY ? (
                <HomeMatchResignationSurvey onSubmit={handleSurveySubmit} />
            ) : (
                <div className={modalWrapper}>
                    <BrandCheckboxCheckedIcon size="6" wrapperColor="var(--colors-primary)" wrapperSize="6" />

                    <Text align="center" strong variant="headline_2">
                        Asystent automatycznych
                        <br /> rekomendacji został wyłączony
                    </Text>
                    <Text align="center" variant="body_copy_0">
                        W każdej chwili możesz włączyć go ponownie, aby otrzymywać nowe oferty
                    </Text>

                    <Button variant="filled_primary" onClick={handleRestore}>
                        {restoreText}
                    </Button>

                    <div className={closeWrap} onClick={handleClose}>
                        <Highlight className={css({height: "40px"})}>{closeText}</Highlight>
                    </div>
                </div>
            )}
        </Modal>
    );
};

const modalWrapper = css({
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 3,
    justifyContent: "center",
    mx: 4,
    p: 3
});

const closeWrap = css({
    alignItems: "center",
    cursor: "pointer",
    display: "flex",
    height: "56px",
    justifyContent: "center"
});
import {useState} from "react";
import {useHistory, useLocation, useParams} from "react-router";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {useModal} from "@pg-design/modal-module";
import {Highlight, Text} from "@pg-design/text-module";
import {kmAppLink, SiteSlug} from "@pg-mono/km-routes";

import {Modal} from "../../../components/modal/Modal";
import {HomeMatchResignationSurvey} from "../../home_match/components/home_match_resignation_survey/HomeMatchResignationSurvey";
import {useHomeMatchResignationSurveySubmit} from "../../home_match/hooks/use_home_match_resignation_survey_submit";
import {zIndexes} from "../../km_app/constants/z_indexes";
import {usePostUserHomeMatchPreleadResignationMutation} from "../../user/api/user_api";
import {useHomeMatchPreferences} from "../../user/hooks/use_home_match_preferences";
import {hitHmRecommendationsUnsubscribe} from "../tracking/hit_hm_recommendations_unsubscribe";
import {getResignationSource} from "../utils/get_resignation_source";

enum HomeMatchUnsubscribeStep {
    SURVEY = "survey",
    SUCCESS = "success"
}

const closeText = "Zamknij";
const restoreText = "Przywróć teraz";

export const HomeMatchUnsubscribeView = () => {
    const params = useParams<{login_token: string}>();
    const location = useLocation();
    const history = useHistory();

    const [step, setStep] = useState(HomeMatchUnsubscribeStep.SURVEY);

    const [postUserHomeMatchPreleadResignation] = usePostUserHomeMatchPreleadResignationMutation();
    const {switchHomeMatchPreferences} = useHomeMatchPreferences();
    const {closeModal, modalProps} = useModal();

    const searchParams = new URLSearchParams(location.search);
    const resignationSource = getResignationSource({
        verifiedEmail: searchParams.get("verifiedEmail"),
        verifiedSMS: searchParams.get("verifiedSMS")
    });

    const handleCloseModal = () => {
        closeModal();
        history.push(kmAppLink.site.user.subscriptionWithParams({site: SiteSlug.KM}));
    };

    const handleSurveySubmit = useHomeMatchResignationSurveySubmit({
        disableHomeMatch: async () => {
            if (!params.login_token) throw new Error("Missing login token");

            await postUserHomeMatchPreleadResignation({login_token: params.login_token, resignation_source: resignationSource});
        },
        onError: handleCloseModal,
        onSuccess: () => setStep(HomeMatchUnsubscribeStep.SUCCESS)
    });

    const handleRestore = async () => {
        hitHmRecommendationsUnsubscribe(restoreText);
        await switchHomeMatchPreferences(true);
        handleCloseModal();
    };

    const handleClose = () => {
        hitHmRecommendationsUnsubscribe(closeText);
        handleCloseModal();
    };

    return (
        <Modal {...modalProps} isOpen zIndex={zIndexes.listingModal} onModalClose={handleCloseModal}>
            {step === HomeMatchUnsubscribeStep.SURVEY ? (
                <HomeMatchResignationSurvey onSubmit={handleSurveySubmit} />
            ) : (
                <div className={modalWrapper}>
                    <BrandCheckboxCheckedIcon size="6" wrapperColor="var(--colors-primary)" wrapperSize="6" />

                    <Text align="center" strong variant="headline_2">
                        Asystent automatycznych
                        <br /> rekomendacji został wyłączony
                    </Text>
                    <Text align="center" variant="body_copy_0">
                        W każdej chwili możesz włączyć go ponownie, aby otrzymywać nowe oferty
                    </Text>

                    <Button variant="filled_primary" onClick={handleRestore}>
                        {restoreText}
                    </Button>

                    <div className={closeWrap} onClick={handleClose}>
                        <Highlight className={css({height: "40px"})}>{closeText}</Highlight>
                    </div>
                </div>
            )}
        </Modal>
    );
};

const modalWrapper = css({
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 3,
    justifyContent: "center",
    mx: 4,
    p: 3
});

const closeWrap = css({
    alignItems: "center",
    cursor: "pointer",
    display: "flex",
    height: "56px",
    justifyContent: "center"
});
